import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface PanelCardProps {
  title?: ReactNode;
  badge?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function PanelCard({
  title,
  badge,
  action,
  children,
  className,
}: PanelCardProps) {
  const hasHeader =
    title !== undefined || badge !== undefined || action !== undefined;
  return (
    <div
      className={cn(
        'flex flex-col bg-surface border border-border rounded-lg overflow-hidden',
        className
      )}
    >
      {hasHeader && (
        <div
          className={cn(
            'flex items-center gap-2.5',
            'px-[14px] py-2.5 bg-surfaceAlt border-b border-borderSoft'
          )}
        >
          {title !== undefined && (
            <div className="font-bold text-xs uppercase tracking-[.06em] text-text">
              {title}
            </div>
          )}
          {badge}
          <div className="flex-1" />
          {action && <div className="flex items-center gap-1">{action}</div>}
        </div>
      )}
      <div className="flex-1">{children}</div>
    </div>
  );
}

PanelCard.displayName = 'PanelCard';

export default PanelCard;
